/* tslint:disable */

/**
 */
export class MembershipType {
    id?: number;
    name?: string;
    deduction?: number;
    code?: number;
    company_id?: number;
    created_at?: string;
    updated_at?: string;
}
